import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllOrders = createAsyncThunk(
    'order/getAllOrders',
    async ({ skip, limit, search, status, customer_id, agent_id }, { rejectWithValue }) => {
        try {
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;
            if (status) params.status = status;
            if (customer_id) params.customer_id = customer_id;
            if(agent_id) params.customer_id = customer_id;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/orders`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const getOrderById = createAsyncThunk(
    'order/getOrderById',
    async ({ id }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/orders/${id}`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const addNewOrder = createAsyncThunk(
    'order/addNewOrder',
    async (orderData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(orderData);

            const response = await axios.post(`${PUBLIC_BASE_URL}/orders/create-order`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editOrder = createAsyncThunk(
    'order/editOrder',
    async (updatedData, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);
            const response = await axios.put(`${PUBLIC_BASE_URL}/orders/update-order-info`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);
